import { useInitial } from "./useInitial";

import React from "react";

const ComponentPreviews = React.lazy(() => import("./previews"));

export {
    ComponentPreviews,
    useInitial,
};